module.exports = __webpack_public_path__ + "img/SOS982x640_High3.bec6f057.jpg";